module.exports = __webpack_public_path__ + "static/media/S1-32-Wormyd-cod63.79c4ce5b.png";